import { getApiUrl } from '../utils/apiUrl';

const API_BASE = getApiUrl();

export const fetchUserQuickActions = async (token) => {
  const res = await fetch(`${API_BASE}/user-quick-actions`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Kunne ikke hente hurtighandlinger');
  return res.json();
};

export const saveUserQuickActions = async (token, widgetIds) => {
  const res = await fetch(`${API_BASE}/user-quick-actions`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ widgetIds }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Kunne ikke lagre hurtighandlinger');
  }
  return res.json();
};
